/**
 * MathXY - AI-Powered Adaptive Math Learning Platform
 * Copyright (c) 2025 Srilesh Kannoly. All rights reserved.
 * Licensed under the MIT License. See LICENSE file for details.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';

import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import App from './App.tsx';
import { initPWA } from './pwa';
import './index.css';

// Initialize PWA (Service Worker) with bot protection
initPWA();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
